import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Set Mapbox access token
mapboxgl.accessToken = process.env.REACT_APP_MAPBOXGL_ACCESS_TOKEN;

const containerStyle = { width: "100%", height: "500px" };

const GoogleMapComponent = ({ location }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!mapContainerRef.current || !location) return;

    // Initialize map only once
    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v12",
        center: [location.lng, location.lat],
        zoom: 15,
      });

      // Add navigation controls
      mapRef.current.addControl(new mapboxgl.NavigationControl(), "top-right");

      // Create initial marker
      markerRef.current = new mapboxgl.Marker({ color: "#2563EB" })
        .setLngLat([location.lng, location.lat])
        .addTo(mapRef.current);
    }

    return () => {
      // Cleanup on unmount
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  // Update marker and center when location changes
  useEffect(() => {
    if (!mapRef.current || !location) return;

    const lngLat = [location.lng, location.lat];

    // Update marker position
    if (markerRef.current) {
      markerRef.current.setLngLat(lngLat);
    } else {
      markerRef.current = new mapboxgl.Marker({ color: "#2563EB" })
        .setLngLat(lngLat)
        .addTo(mapRef.current);
    }

    // Center map on new location
    mapRef.current.flyTo({
      center: lngLat,
      zoom: 15,
      essential: true,
    });
  }, [location]);

  return <div ref={mapContainerRef} style={containerStyle} />;
};

export default GoogleMapComponent;
